var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',{staticClass:"h-100p",attrs:{"body-style":{ padding: '0', height: '100%' }}},[_c('bpmn-main',_vm._g(_vm._b({scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(item,key){return {key:key,fn:function(data){return [_vm._t(key,null,null,data)]}}})],null,true)},'bpmn-main',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }